export const MISSATGE_NO_CONEXIO_SERVIDOR =
  "No hi ha connexió amb el servidor. Consulteu amb el responsable de l'aplicació.";
export const MISSATGE_ERROR_SERVIDOR = "Error Servidor";
export const MISSATGE_SESSIO_CADUCADA = "Sessió caducada. Torneu a fer login.";
export const MISSATGE_SESSIO_JA_INICIADA =
  "Ja hi ha una sessió iniciada en una altra pestanya.";
export const MISSATGE_SESSIO_TANCAR =
  MISSATGE_SESSIO_JA_INICIADA + " Tanqueu-la abans d'iniciar-ne una de nova.";
export const MISSATGE_NO_ACCES_RUTA =
  "No es pot accedir a aquesta ruta perque hi ha una sessio iniciada en una altra pestanya.";
export const MISSATGE_SESSIO_ESBORRAR_TITOL = "Sessió activa esborrada";
export const MISSATGE_SESSIO_ESBORRAR_DESCRIPTION =
  "S'han esborrat les dades de control de sessió.";
export const MISSATGE_SESSIO_BLOQUEJADA = "Inici de sessió bloquejat";
export const MISSATGE_CAMP_OBLIGATORI = "Aquest camp és obligatori.";
export const RANG_MIN_MAX_CARACTERS_CONTRASENYA = [5, 16]; //Replicat a constants.js de servidor. Valors has de ser coincidents.
export const MISSATGE_CONTRASENYA_LONGITUD = `La contrasenya ha de tenir una longitud entre ${RANG_MIN_MAX_CARACTERS_CONTRASENYA[0]} i ${RANG_MIN_MAX_CARACTERS_CONTRASENYA[1]}.`;
export const MISSATGE_CANVI_CONTRASENYA_TITOL = "Canvi de contrasenya.";
export const MISSATGE_CONTRASENYA_NO_COINCIDEIXEN =
  "Les contrasenyes introduïdes no coincideixen.";
export const MISSATGE_CANVI_CONTRASENYA_ERROR =
  "Error canviant la contrasenya.";
export const MISSATGE_CANVI_CONTRASENYA_OK =
  "Contrasenya modificada correctament.";
export const MISSATGE_RESTABLIR_CONTRASENYA_ERROR =
  "Error restablint la contrasenya.";
export const MISSATGE_RESTABLIR_CONTRASENYA_OK =
  "Contrasenya restablerta correctament.";
export const MISSATGE_USUARI_NO_ACTIU = "Aquest observador no està actiu.";
export const MISSATGE_USUARI_NO_AUTORITZACIO = "Error autorització usuari";
export const MISSATGE_TORNAR_FER_LOGIN =
  "Torneu a fer login. Si el problema persisteix, contacti amb l'administrador.";

export const MISSATGE_MUNICIPI_NO_TROBAT = "No s'ha trobat municipi";
export const MISSATGE_COMARCA_NO_TROBADA = "No s'ha trobat comarca";

export const MISSATGE_SPIN_ESPECIES = "Carregant Espècies...";
export const MISSATGE_SPIN_CANVI_CONTRASENYA = "Canviant Contrasenya...";
export const MISSATGE_SPIN_OBSERVACIONS = "Realitzant el canvi...";
export const MISSATGE_SPIN_VISUALITZACIO = "Carregant Observacions...";
export const MISSATGE_SPIN_PARAMETRES_CERCA = "Carregant Observacions...";
export const MISSATGE_SPIN_OBSERVADORS = "Carregant Observadors...";
export const MISSATGE_SPIN_ALTA_OBSERVADOR = "Alta Observador...";
export const MISSATGE_SPIN_BAIXA_OBSERVADOR = "Baixa Observador...";
export const MISSATGE_SPIN_BAIXA_INDRET = "Baixa Indret...";
export const MISSATGE_SPIN_BAIXA_INDIVIDU = "Baixa Individu...";
export const MISSATGE_SPIN_INDRETS = "Carregant Indrets...";
export const MISSATGE_SPIN_INDIVIDUS = "Carregant Individus...";
export const MISSATGE_SPIN_PERFIL = "Carregant Dades Perfil...";
export const MISSATGE_SPIN_OBSERVADOR = "Carregant Dades Observador...";
export const MISSATGE_SPIN_INDRET = "Carregant Dades Indret...";
export const MISSATGE_SPIN_INDIVIDU = "Carregant Dades Individu...";
export const MISSATGE_SPIN_ALTA_FOTO = "Pujant Foto...";
export const MISSATGE_SPIN_INFORME_OBSERVADOR = "Generant informe...";

export const MISSATGE_ALTA_OBSERVADOR_ERROR = "Error fent alta observador.";
export const MISSATGE_ALTA_OBSERVADOR_OK =
  "Alta observador creada correctament.";
export const MISSATGE_ALTA_OBSERVADOR_TITOL = "Alta d'observador.";

export const MISSATGE_BAIXA_OBSERVADOR_ERROR = "Error fent baixa observador.";
export const MISSATGE_BAIXA_OBSERVADOR_OK =
  "Baixa observador creada correctament.";
export const MISSATGE_BAIXA_OBSERVADOR_TITOL = "Baixa d'observador.";
export const MISSATGE_DATA_BAIXA_ANTERIOR_DATA_ALTA =
  "La data de baixa no pot ser anterior a la data d'alta.";

export const MISSATGE_BAIXA_INDRET_ERROR = "Error fent baixa indret.";
export const MISSATGE_BAIXA_INDRET_OK = "Baixa indret realitzada correctament.";
export const MISSATGE_BAIXA_INDRET_TITOL = "Baixa d'indret.";

export const MISSATGE_BAIXA_INDIVIDU_ERROR = "Error fent baixa individu.";
export const MISSATGE_BAIXA_INDIVIDU_OK =
  "Baixa individu realitzada correctament.";
export const MISSATGE_BAIXA_INDIVIDU_TITOL = "Baixa d'individu.";

export const MISSATGE_NO_VALOR_MODIFICAT = "No s'ha modificat cap valor.";
export const MISSATGE_EXTENSIONS_PERMESES =
  "L'extensió de la foto no correspon a cap de les permeses: .png, .jpg";
export const MISSATGE_ERROR_FOTO = "Error recuperant l'imatge seleccionada.";
export const MISSATGE_LONGITUD_NOM_FITXER_PERMESA = 120;

export const MISSATGE_FITXER_INCORRECTE = "Error seleccionant el fitxer.";

export const MISSATGE_TRIAR_DATES = "Cal triar les dates.";
export const MISSATGE_TRIAR_ESPECIE = "Cal triar l'espècie.";
export const MISSATGE_TRIAR_FENOFASE = "Cal triar la fenofase.";
export const MISSATGE_NO_OBSERVACIONS_TROBADES =
  "No s'han trobat observacions per als paràmetres de cerca escollits";
export const MISSATGE_NO_CONSULTA_OBSERVACIONS_DIA =
  "No es poden consultar observacions pel dia escollit";
export const MISSATGE_ERROR_DATA_ACTUAL = "Error al recuperar la data actual";
export const MISSATGE_NO_PARAMETRES_CANVIATS =
  "No s'han canviat els paràmetres de cerca";
export const MISSATGE_CANVI_COMENTARI_TITOL = "Comentari.";
export const MISSATGE_COMENTARI_MAX_LENGTH =
  "Ha superat el nombre màxim de caràcters:";
export const MISSATGE_COMENTARI_BUIT = "El camp Comentari està buit";
export const TAULA = "Taula";
export const MAPA = "Mapa";

export const TITOL_INTRODUCCIO = "Introduir Observacions";
export const TITOL_VISUALITZACIO = "Visualitzar Observacions";
export const TITOL_VISUALITZACIO_OBSERVADORS = "Visualitzar Observadors";
export const TITOL_OBSERVADORS = "Observadors";
export const TITOL_CREAR_OBSERVADOR = "Crear Observador";
export const TITOL_EDITAR_OBSERVADOR = "Editar Observador";
export const TITOL_DADES_OBSERVADOR = "Dades Observador";
export const TITOL_ALTA_OBSERVADOR = "Alta observador";
export const TITOL_BAIXA_OBSERVADOR = "Baixa observador";
export const TITOL_INDRETS = "Indrets";
export const TITOL_CREAR_INDRET = "Crear Indret";
export const TITOL_EDITAR_INDRET = "Editar Indret";
export const TITOL_DADES_INDRET = "Dades Indret";
export const TITOL_BAIXA_INDRET = "Baixa Indret";
export const TITOL_INDIVIDUS = "Individus";
export const TITOL_CREAR_INDIVIDU = "Crear Individu";
export const TITOL_EDITAR_INDIVIDU = "Editar Individu";
export const TITOL_DADES_INDIVIDU = "Dades Individu";
export const TITOL_BAIXA_INDIVIDU = "Baixa Individu";
export const TITOL_PERFIL = "Perfil";
export const TITOL_AVIS_LEGAL = "Avís Legal";
export const TITOL_ACCESSIBILITAT = "Declaració d'accessibilitat";
export const TITOL_FENOFASES = "Fenofases";
export const TITOL_PUJAR_FOTOS = "Enviar Fotos";

export const MIDA_MAX_FOTO_IND_FENOFASE_VARIOS_BYTES = 10000000;
export const MIDA_MAX_FOTO_FENOFASE_BYTES = 1000000;
export const MIDA_MAX_FOTO_OBSERVADOR_BYTES = 500000;
export const MIDA_MAX_FOTO_INDRET_BYTES = 1000000;
export const NUM_MAX_FOTOS_INDRET = 3;
export const NUM_MAX_FOTOS_FENOFASES = 5; //Mateix valor a num_max_fotos_fenofases a fitxer server/src/constants
export const ALTURA_NOTIFICACIO_EN_PIXELS = 80;
export const USER_ADMIN = 1;
export const USER_OBSERVADOR = 2;

export const TEXT_QUAN_NO_HI_HA_DADA = "--";

export const OBSERVADOR_EXPERT_VALOR_DEFECTE = true;
export const OBSERVADOR_ACTIU_VALOR_DEFECTE = true;
export const OBSERVADOR_PERMIS_MOSTRAR_NOM_VALOR_DEFECTE = false;

export const ORIENTACIO_NOM_VALOR_DEFECTE = true;
export const ORIGEN_NOM_VALOR_DEFECTE = true;
export const TRACTAMENT_NOM_VALOR_DEFECTE = true;
export const IRRIGACIO_NOM_VALOR_DEFECTE = true;

export const ORIENTACIO_NOM_VALOR_SOLANA = "Solana";
export const ORIENTACIO_NOM_VALOR_OBAGA = "Obaga";

export const alturaMissatgeErrorEnPixels = 80;
export const alturaNotificacioEnPixels = 80;
export const VALOR_MAX_DESCRIPCIO_INDRET = 255;
export const NUM_DECIMALS_DISTACIA_MAR = 2;
export const DISTANCIA_MAR_MIN = 0;
export const DISTANCIA_MAR_MAX = 500;
export const VALOR_MAX_DESCRIPCIO_INDIVIDU = 255;
export const VALOR_MIN_ALÇADA_INDIVIDU = 0;
export const VALOR_MAX_ALÇADA_INDIVIDU = 3143;
export const NUM_DECIMALS_COORDENADES = 6;
export const MAX_BOUNDS_COORDENADES = [
  [43, -0.06],
  [40.37, 3.57]
];
export const MAX_NATIVE_ZOOM_CATALUNYA = 14;
export const MIN_NATIVE_ZOOM_CATALUNYA = 8;

export const INDRETS_ORIENTACIO = [
  "Est",
  "Est_Nord-est",
  "Est_Sud-est",
  "Nord",
  "Nord-est",
  "Nord_Nord-est",
  "Nord_Nord-oest",
  "Nord-oest",
  "Oest",
  "Oest_Nord-oest",
  "Oest_Sud-oest",
  "Sud",
  "Sud-est",
  "Sud-oest",
  "Sud_Sud-est",
  "Sud_Sud-oest"
];

export const INDRETS_CLIMA = [
  "Oceànic",
  "Mediterrani continental humit",
  "Mediterrani continental sub-humit",
  "Mediterrani continental sec",
  "Mediterrani litoral central",
  "Mediterrani litoral nord",
  "Mediterrani litoral sud",
  "Mediterrani pirinenc occidental",
  "Mediterrani pirinenc oriental",
  "Mediterrani prelitoral central",
  "Mediterrani prelitoral nord",
  "Mediterrani prelitoral sud",
  "Mediterrani prepirinenc occidental",
  "Mediterrani prepirinenc oriental"
];

export const NOM_FITXER_AJUDA = "Ajuda_Fenocat.pdf";
export const ID_CLASSE_VEGETAL = 1;
